import angular from 'angular';

angular.module('commonServices').filter('compoundDaysTime', [
  '$translate',
  function ($translate) {
    return function (decimalHours, hoursInDay) {
      if (decimalHours == null || isNaN(decimalHours)) return '';

      var dAbbr = $translate.instant('DaysAbbreviated') || 'd';
      var hAbbr = $translate.instant('HoursAbbreviated') || 'h';
      var mAbbr = $translate.instant('MinutesAbbreviated') || 'm';
      var sign = decimalHours < 0 ? '-' : '';

      var totalMin, days, h, m, parts;

      if (!hoursInDay || hoursInDay <= 0) {
        totalMin = Math.round(Math.abs(decimalHours) * 60);
        h = Math.floor(totalMin / 60);
        m = totalMin % 60;
        parts = [];
        if (h > 0) parts.push(h + hAbbr);
        if (m > 0 || parts.length === 0) parts.push(m + mAbbr);
        return sign + parts.join(' ');
      }

      var abs = Math.abs(decimalHours);
      days = Math.floor(abs / hoursInDay);
      var remainderHours = abs - days * hoursInDay;
      var minutes = Math.round(remainderHours * 60);

      var minutesInDay = Math.round(hoursInDay * 60);
      if (minutes >= minutesInDay) {
        days += 1;
        minutes -= minutesInDay;
      }

      h = Math.floor(minutes / 60);
      m = minutes % 60;

      parts = [];
      if (days > 0) parts.push(days + dAbbr);
      if (h > 0) parts.push(h + hAbbr);
      if (m > 0 || parts.length === 0) parts.push(m + mAbbr);
      return sign + parts.join(' ');
    };
  },
]);
